module.exports = __webpack_public_path__ + "img/logo_email.c582e086.svg";